import React from 'react';
import { useSearchParams } from 'react-router-dom';
import CreateInvoice from './CreateInvoice';
import UploadReceipt from './UploadReceipt';

/**
 * /create — manual invoice form.
 * /create?draft=<id> — same review UI as after /api/upload, prefilled from draft.
 */
function CreateRoute() {
  const [params] = useSearchParams();
  if (params.get('draft')) {
    return <UploadReceipt />;
  }
  return <CreateInvoice />;
}

export default CreateRoute;
